export default __webpack_public_path__ + "static/media/Logo 4.e490702c.png";